import { useState } from "react";
import { ConfirmModal, IConfirmModalProps } from "src/shared/components";

interface IUseConfirmModal
  extends Omit<IConfirmModalProps, "open" | "onClose"> {
  resolveOnCancel?: boolean;
  resolveOnClose?: boolean;
}

export const useConfirmModal = (props?: IUseConfirmModal) => {
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => setShowModal(false);

  const {
    resolveOnCancel = false,
    resolveOnClose = false,
    cancelBtnProps,
    onResolve,
    ...restProps
  } = props || {};

  const mergedCancelBtnProps: IConfirmModalProps["cancelBtnProps"] | undefined =
    resolveOnCancel
      ? {
          ...cancelBtnProps,
          onClick: (e) => {
            cancelBtnProps?.onClick?.(e);
            e?.stopPropagation?.();
            if (onResolve) {
              onResolve({ result: false, closeModal });
            } else {
              closeModal();
            }
          },
        }
      : cancelBtnProps;

  const handleOnClose = () => {
    if (resolveOnClose && onResolve) {
      onResolve({ result: false, closeModal });
    } else {
      closeModal();
    }
  };

  const modal = showModal ? (
    <ConfirmModal
      {...restProps}
      cancelBtnProps={mergedCancelBtnProps}
      onResolve={(args) => onResolve?.({ ...args, closeModal })}
      onClose={handleOnClose}
      open={showModal}
    />
  ) : null;

  return {
    modal,
    showModal: () => setShowModal(true),
    closeModal,
  };
};
